<script lang="ts">
	import { onMount } from 'svelte';
	import { appStore } from '../stores/appStore';
	import { getUserActivities, type Activity } from '../utils/activity';

	let profile: any = $state(null);
	let activities = $state<Activity[]>([]);
	let loading = $state(true);
	let error = $state('');

	// Subscribe to store
	appStore.subscribe(state => {
		profile = state.profile;
	});

	onMount(async () => {
		await loadActivities();
	});

	async function loadActivities() {
		try {
			loading = true;
			error = '';
			activities = await getUserActivities(6); // Fetch latest 6 activities
		} catch (e: any) {
			error = e.message || 'Failed to load activities';
			console.error('Error loading activities:', e);
		} finally {
			loading = false;
		}
	}

	function getStatusColor(status?: string) {
		if (!status) return '';
		return status === 'success' ? 'text-green-600 dark:text-green-400' : status === 'failed' ? 'text-red-600 dark:text-red-400' : '';
	}
</script>

<div class="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700">
	<div class="p-6 border-b border-gray-200 dark:border-gray-700">
		<h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100">Recent Activity</h2>
	</div>

	<div class="divide-y divide-gray-200 dark:divide-gray-700 max-h-96 overflow-y-auto">
		{#if loading}
			<div class="p-8 text-center">
				<div class="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mb-2"></div>
				<p class="text-sm text-gray-600 dark:text-gray-400">Loading activities...</p>
			</div>
		{:else if error}
			<div class="p-8 text-center">
				<p class="text-sm text-red-600 dark:text-red-400">{error}</p>
			</div>
		{:else if activities.length === 0}
			<div class="p-8 text-center">
				<p class="text-sm text-gray-600 dark:text-gray-400">No recent activity</p>
				<p class="text-xs text-gray-500 dark:text-gray-500 mt-1">
					Create a repository or star some projects to get started!
				</p>
			</div>
		{:else}
			{#each activities as activity}
				<div class="p-4 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors">
					<div class="flex items-start space-x-3">
						<div class="flex-shrink-0 text-2xl">{activity.icon}</div>
						<div class="flex-1 min-w-0">
							<p class="text-sm text-gray-900 dark:text-gray-100">
								<span class="font-medium">{activity.user}</span>
								<span class="ml-1">{activity.message}</span>
							</p>
							{#if activity.repo}
								<div class="mt-1 flex items-center space-x-2">
									<a
										href="#/users/{profile?.userName}/repositories/{activity.repo}"
										class="text-sm text-indigo-600 dark:text-blue-400 hover:text-indigo-700 dark:hover:text-blue-300 font-medium"
									>
										{activity.repo}
									</a>
									{#if activity.status}
										<span class="text-xs {getStatusColor(activity.status)} font-medium">
											● {activity.status}
										</span>
									{/if}
								</div>
							{/if}
							<p class="text-xs text-gray-500 dark:text-gray-400 mt-1">{activity.time}</p>
						</div>
					</div>
				</div>
			{/each}
		{/if}
	</div>

	<div class="p-4 border-t border-gray-200 dark:border-gray-700">
		<a href="#/activity" class="text-sm text-indigo-600 dark:text-blue-400 hover:text-indigo-700 dark:hover:text-blue-300 font-medium">
			View all activity
		</a>
	</div>
</div>
